var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-background"},[_c('div',{class:['header-wrapper', { 'header-centered': _vm.centeredLogo }]},[_c('Asset',{attrs:{"name":'logo-white.svg',"alt":"Logo","title":"Logo","version":null}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }